import { apiSlice } from "@/redux/rtk/features/apiSlice/apiSlice";

export const universityApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUniversities: builder.query({
      query: () => ({
        url: "university?query=all",
      }),
      providesTags: ["University"],
    }),
    addUniversity: builder.mutation({
      query: (data) => ({
        url: "university",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["University"],
    }),
  }),
});

export const {
  useGetUniversitiesQuery,
  useAddUniversityMutation,
} = universityApi;

